import React, { useEffect } from 'react';
import { List as RaList, Pagination as RaPagination } from 'react-admin';

import { ViewTitle } from './ViewTitle';
import { useApiHubPreference, readApiHubPreference } from '../preferences';
import { Typography } from '@material-ui/core';

/**
 * A List component which displays the react-admin list with the title above.
 *
 * @param {*} props The react-admin list properties
 * @param {string} props.resource The resource to fetch.
 * @param {int} props.perPage The perPage option, default to 12.
 *
 */
export const List = props => {
    const { className, resource, perPage = PER_PAGE_DEFAULT } = props;

    // Get the initial per page preference per resources
    // The readApiHubPreference method is used
    // instead of the useApiHubPreference hook
    // to not rerender the whole list each time the perPage property changes.
    // See the <Pagination /> component above to understand the complete usage of the per page preferences.
    const perPagePreference = readApiHubPreference(
        `perPage/${resource}`,
        perPage
    );

    return (
        <div className={className}>
            {localStorage.getItem('isSSO') === 'false' ? (
                <>
                    <ViewTitle />
                </>
            ) : (
                <Typography variant="h5" component="h2" color="inherit">
                    {localStorage.getItem('userType')} <ViewTitle />
                </Typography>
            )}
            <RaList
                {...props}
                perPage={parseInt(perPagePreference, 10)}
                pagination={<Pagination />}
            />
        </div>
    );
};

/**
 * A List component which displays the react-admin list with the title above
 * with no pagination.
 *
 * @param {*} props The react-admin list properties
 *
 */
export const NoPaginationList = props => {
    const { className } = props;

    return (
        <div className={className}>
            <ViewTitle />
            <RaList {...props} />
        </div>
    );
};

const PER_PAGE_DEFAULT = 12;
const PER_PAGE_OPTIONS = [12];

const Pagination = props => {
    const { resource, perPage, setPerPage } = props;

    const [perPagePreference, setPerPagePreference] = useApiHubPreference(
        `perPage/${resource}`,
        perPage
    );

    useEffect(() => {
        if (perPagePreference !== perPage) {
            setPerPagePreference(perPagePreference);
        }
    }, [perPage, perPagePreference, setPerPage, setPerPagePreference]);

    const handleSetPerPage = newPerPage => {
        setPerPage(newPerPage);
    };

    return (
        <RaPagination
            {...props}
            perPage={parseInt(perPagePreference, 10)}
            setPerPage={handleSetPerPage}
            rowsPerPageOptions={PER_PAGE_OPTIONS}
        />
    );
};
